import type { RootState } from '../index'

export const getPageInfo = (state: RootState) =>
  state.administration?.pageInfo ?? null

const emptyArray = []
export const getItems = (state: RootState) =>
  state.administration?.items ?? emptyArray

export const getSelectedItems = (state: RootState) =>
  state?.administration?.selectedItems ?? emptyArray

export const getOptions = (state: RootState) => state.administration.options
export const getTableName = (state: RootState) => state.administration.tableName
export const getSorting = (state: RootState) => state.administration.sorting
